export default "__VITE_ASSET__Beg$$W09__"